/* eslint-disable */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-react-common";
import * as API from "../../../framework/API/api";
import { COLUMNSTYPE, ENTITYNAME, LOCALSTORAGE_KEY, MEDIACATEGORIES, VERSION_TYPE, TOAST_TYPES } from "../../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import SaveButton from "../../../framework/forms/helpercomponents/buttons/SaveButton";
import CancelButton from "../../../framework/forms/helpercomponents/buttons/CancelButton";
import ActionButton from "../../../framework/forms/helpercomponents/buttons/ActionButton";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../../framework/forms/helpercomponents/Loader";
import { TimeCell } from "../../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { utility } from "../../../framework/utility/utilityProvider";
import { ImageCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import { ArrayCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import { LookupCell } from "../../../framework/forms/helpercomponents/CustomGridCells/LookupCell";
import { DateOnlyCell, LocalDateTimeColumn } from "../../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { HrefCell } from "../../../framework/forms/helpercomponents/CustomGridCells/HrefCell";
import { MyToggleButton } from "../../../framework/forms/helpercomponents/CustomGridCells/MyToggleButton";
import { CheckboxCell } from "../../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell";
import { EnumCell } from "../../../framework/forms/helpercomponents/CustomGridCells/EnumCell";
import { ContentArrayImageCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ContentArrayImageCell";
import { ProviderCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ProviderCell";
import castTypeCell from "../../../framework/forms/helpercomponents/CustomGridCells/CastTypeCell";
import { MultiLangArrayCell } from "../../../framework/forms/helpercomponents/CustomGridCells/MultiLangArrayCell";
import PreferenceRoundButton from "../../../framework/forms/helpercomponents/buttons/PreferenceRoundButton";
import { useTranslation } from "../../../locale/useTranslation";
import BossDialog from "../../../components/BossDialog";
import { UserPreference } from "../../userPreference/UserPreference";
import { TransmissionTypeStatusCell } from "../../../components/TransmissionTypeStatusCell";
import MAMStatusCell from "../../../components/MAMStatusCell";
import ToastNotification from "../../../components/ToastNotification";

const DATA_ITEM_KEY = "SID";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const AttachMediaCollectionSelection = (props) => {

    let page_take = props.page_take ?? 50;
    let hideSeriesSeason = props.hideSeriesSeason ?? false;
    let showAddMedia = props.showAddMedia ?? false;
    let enableMutliSelect = props.enableMutliSelect ?? false;
    let showPreferenceButton = props.showPreferenceButton ?? true;
    let isPageable = props.isPageable ?? true;

    const navigate = useNavigate();
    const lang = useTranslation();
    const gridRef = useRef();
    const Company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

    const [gridData, setGridData] = useState([]);
    const [total, setTotal] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [mediaCategories, setMediaCategories] = useState([]);
    let [selectedMediaCategory, setSelectedMediaCategory] = useState(props?.mediaCategory ?? {});

    const [selectedState, setSelectedState] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [dataColumns, setDataColumns] = useState(props.customColumns ?? []);
    const [selectedLanguage] = useState(Company?.Language ?? {});
    const [showPreferences, setShowPreferences] = useState(false);
    const [filterObj, setFilterObj] = useState(null);
    const [page, setPage] = useState({ skip: 0, take: page_take });

    const MyDatalookupCell = (props) => (
        <LookupCell {...props} dataColumns={dataColumns} />
    );
    const MyDateCell = (props) => <DateOnlyCell {...props} />;
    const MyArrayCell = (props) => <ArrayCell {...props} />;
    const MyHrefCell = (props) => <HrefCell {...props} />;

    const MyCustomToggleButton = (props) => (
        <MyToggleButton {...props} entityName={props.entityname} size={"small"} />
    );
    const MyMultiLangArrayCell = (props) => (
        <MultiLangArrayCell selectedLang={selectedLanguage} {...props} />
    )

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        const mediaCategoriesRes = await API.getData(ENTITYNAME.MediaCategory);
        let mediaCategories = mediaCategoriesRes?.data || [];
        // Remove Series & Season if required
        if (hideSeriesSeason) {
            mediaCategories = mediaCategories.filter((item) => item.SID !== MEDIACATEGORIES.Series && item.SID !== MEDIACATEGORIES.Season);
        }
        setMediaCategories(mediaCategories);
        const defaultMediaCategory = props?.mediaCategory ?? mediaCategories[0] ?? {};
        setSelectedMediaCategory(defaultMediaCategory);
        // Load data
        await loadData({ searchText, mediaCategory: defaultMediaCategory });
    };

    const loadData = async ({ searchText = "", pagination = page, mediaCategory = selectedMediaCategory }) => {

        try {

            setIsLoading(true);
            let columns = [];

            if (props?.data?.length > 0) {
                setGridData(props.data);
                setDataColumns(props.customColumns ?? columns);
                setIsLoading(false);
                return;
            }

            // Get filter object
            let filter = getFilterQueryAndEntityNameForMediaCategory(mediaCategory);
            setFilterObj(filter);

            if (props?.customColumns && props?.customColumns?.length > 0) {
                columns = props.customColumns;
            } else {
                let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
                columns = await API.getFormData(filter.preferenceEntityName, currentUserId);
            }

            let current_page = pagination.skip / pagination.take + 1;

            let json = filter?.isLong ? await API.getVersionBrowser({ page: current_page, perPage: pagination.take, sort: { _id: 1 }, query: filter.wherestatement, searchText, columns, versionType: [VERSION_TYPE.Both, VERSION_TYPE.Linear, VERSION_TYPE.NonLinear] }) : await API.getEntitiesWithSearch(
                filter.entityName,
                { perPage: pagination.take, page: current_page, query: filter.wherestatement },
                columns,
                searchText
            );
            setGridData(json.data);
            setTotal(json.pagination.total);
            setDataColumns(columns);
            setIsLoading(false);
        } catch (error) {
            console.log("error", error);
            setIsLoading(false);
        }
    };

    const pageChange = async (e) => {
        await loadData({ searchText, pagination: e.page });
        setPage(e.page);
    };

    const getFilterQueryAndEntityNameForMediaCategory = (mediaCategory = selectedMediaCategory) => {
        let obj = {};

        switch (mediaCategory.SID) {

            case MEDIACATEGORIES.Program:
                obj.entityName = ENTITYNAME.MediaEpisodeSegment;
                obj.preferenceEntityName = 'versionBrowser';
                obj.wherestatement = [['SegmentType.SegmentCount', '=', 1], ['MediaEpisode.MediaCategory.SID', '=', MEDIACATEGORIES.Program]];
                obj.isLong = mediaCategory?.isLong;
                break;

            case MEDIACATEGORIES.Episode:
                obj.entityName = ENTITYNAME.MediaEpisodeSegment;
                obj.preferenceEntityName = 'versionBrowser';
                obj.wherestatement = [['SegmentType.SegmentCount', '=', 1], ['MediaEpisode.MediaCategory.SID', '=', MEDIACATEGORIES.Episode]];
                obj.isLong = mediaCategory?.isLong;
                break;

            case MEDIACATEGORIES.Movie:
                obj.entityName = ENTITYNAME.MediaEpisodeSegment;
                obj.preferenceEntityName = 'versionBrowser';
                obj.wherestatement = [['SegmentType.SegmentCount', '=', 1], ['MediaEpisode.MediaCategory.SID', '=', MEDIACATEGORIES.Movie]];
                obj.isLong = mediaCategory?.isLong;
                break;

            case MEDIACATEGORIES.Series:
                obj.entityName = ENTITYNAME.Series;
                obj.preferenceEntityName = 'series';
                obj.wherestatement = ['MediaCategory.SID', '=', MEDIACATEGORIES.Series];
                obj.isLong = mediaCategory?.isLong;
                break;

            case MEDIACATEGORIES.Season:
                obj.entityName = ENTITYNAME.Season;
                obj.preferenceEntityName = 'season';
                obj.wherestatement = ['MediaCategory.SID', '=', MEDIACATEGORIES.Season];
                obj.isLong = mediaCategory?.isLong;
                break;

            case MEDIACATEGORIES.Trailer:
                obj.entityName = ENTITYNAME.MediaEpisode;
                obj.preferenceEntityName = 'program';
                obj.wherestatement = ['MediaCategory.SID', '=', MEDIACATEGORIES.Trailer];
                obj.isLong = mediaCategory?.isLong;
                break;

            case MEDIACATEGORIES.Interstitial:
                obj.entityName = ENTITYNAME.MediaEpisode;
                obj.preferenceEntityName = 'interstitial';
                obj.wherestatement = ['MediaCategory.SID', '=', MEDIACATEGORIES.Interstitial];
                obj.isLong = mediaCategory?.isLong;
                break;

            case MEDIACATEGORIES.Commercial:
                obj.entityName = ENTITYNAME.MediaEpisode;
                obj.preferenceEntityName = 'commercial';
                obj.wherestatement = ['MediaCategory.SID', '=', MEDIACATEGORIES.Commercial];
                obj.isLong = mediaCategory?.isLong;
                break;

            case MEDIACATEGORIES.Filler:
                obj.entityName = ENTITYNAME.MediaEpisode;
                obj.preferenceEntityName = 'filler';
                obj.wherestatement = ['MediaCategory.SID', '=', MEDIACATEGORIES.Filler];
                obj.isLong = mediaCategory?.isLong;
                break;

            case MEDIACATEGORIES.Music:
                obj.entityName = ENTITYNAME.MediaEpisode;
                obj.preferenceEntityName = 'music';
                obj.wherestatement = ['MediaCategory.SID', '=', MEDIACATEGORIES.Music];
                obj.isLong = mediaCategory?.isLong;
                break;
        }
        return obj;
    }

    const onSelectionChange = useCallback(
        (event) => {
            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: DATA_ITEM_KEY,
            });

            setSelectedState(newSelectedState);

        }, [selectedState]
    );

    const onHeaderSelectionChange = useCallback((event) => {

        if (props.mode == 'single') {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `${lang.select_any_one_collection_selection_error_message}` });
            return;
        }

        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);

    }, []);

    //implementing search

    const onSearchEnter = (event) => {
        if (event.key === "Enter") {
            // Cancel the default action, if needed
            event.preventDefault();
            onSearchClick();
        }
    }

    const handleServerSideSearch = (e) => {
        setSearchText(() => e.target.value);

        if (e.target.value == '') {
            loadData({ searchText: '' });
        }
    };

    const onSearchClick = () => {

        if (searchText != '') {
            loadData({ searchText: searchText });
        } else {
            loadData({ searchText: '' });
        }

    }

    const checkIfItemExist = (item) => {

        let isFound = false;
        let existingEntries = props.existingItems ?? [];
        console.log("checking duplicate")
        console.log(item.SID);
        console.log(props);
        if (props.checkDuplicate ?? false) {
            isFound = existingEntries.some(element => {
                console.log("props");
                console.log(props);
                if (element.SID === item.SID) {
                    return true;
                }

                return false;
            });
        }
        console.log("isFound");
        console.log(isFound);
        return isFound;

    };

    //to sendDataList to RailsEditForm and to close the collection
    const onSelection = () => {

        let selectedDataList = [];
        //loop for setting the selected obj in array
        gridData.map((obj) => {
            let key = obj.SID;
            //if true means checked
            if (selectedState[key]) {
                // checking duplicate as well
                if (!checkIfItemExist(obj)) {
                    selectedDataList.push(obj);
                }
            }
        })

        if (selectedDataList.length != 0) {
            props.setDataList(selectedDataList, selectedMediaCategory);
            props.closeForm();
        } else {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `${lang.please_select_first_contract_collection_error_message}` });
        }

    }

    const onAddMedia = () => {
        navigate(`/home/MediaEpisode/${selectedMediaCategory.Description}/0`, { state: { quickEdit: false } })
    }

    const onChange = (e) => {
        selectedMediaCategory = e.target.value;
        setSelectedMediaCategory(selectedMediaCategory);
        setPage({ skip: 0, take: page_take });
        loadData({ searchText, mediaCategory: selectedMediaCategory, pagination: { skip: 0, take: page_take } });
    }

    const onRowDoubleClick = (event) => {
        const item = event.dataItem;

        if (!checkIfItemExist(item)) {
            props.setDataList([item], selectedMediaCategory);
            props.closeForm();
        } else {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `${lang.duplicate_item_selected_error_message}` });
        }
    };

    const onCloseUserPrefence = () => {
        loadData({ searchText });
        setShowPreferences(!showPreferences);
    }

    let timeOut;
    const handleColumnResize = (event) => {
        let lockedCol = event.columns.filter((item) => item?.locked).length ?? 1;
        try {
            if (event.index == 0) return;
            if (dataColumns == undefined || dataColumns.length == 0 || dataColumns.length < event.index) return;
            let column = dataColumns[event.index - lockedCol];
            let payload = {
                entityName: column?.entityName,
                name: column?.name,
                width: event.newWidth
            };
            clearTimeout(timeOut);
            timeOut = setTimeout(() => {
                API.updateUserPreferenceColumnWidth(payload);
            }, 700);
        } catch (error) {
            console.error("Error handling column resize:", error);
        }
    };


    return (
        <BossDialog
            title={props.title ?? lang.add_dialog_header}
            onClose={props.closeForm}
            width={props.width ?? "75vw"}
            height={props.height ?? "auto"}
        >
            <div>
                <div className="flex-container" style={{ marginTop: "-5px" }}>
                    <div className="martb mar" style={{ marginLeft: "-10px" }}>
                        <SaveButton title={lang.select_button_text} style={{ backgroundColor: 'green', borderRadius: "4px" }} onClick={onSelection}></SaveButton>
                        {showAddMedia && <ActionButton title={'Add Media'} name={'Add Media'} onClick={onAddMedia} />}
                        <CancelButton onClick={props.closeForm}></CancelButton>
                    </div>
                    <div className="d-flex flex-column" style={{ marginTop: "12px" }}>
                        <DropDownList
                            style={{ width: "125px" }}
                            data={mediaCategories}
                            textField="Description"
                            dataItemKey="SID"
                            value={selectedMediaCategory}
                            onChange={onChange}
                        />
                    </div>
                    <div className="flex-container-reverse flex-item-auto" style={{ marginTop: "7px" }}>
                        <div className="input-group input-group mb-3" style={{ width: "220px" }}>
                            <input type="text" className="form-control shadow-inset-2 pt-0 pb-0" id="searchInput" aria-label="type 2 or more letters" placeholder={lang.search_button_text} onKeyDown={onSearchEnter} onChange={handleServerSideSearch} />
                            <button id="search" style={{ border: "0px", backgroundColor: "white" }} onClick={onSearchClick}>
                                <div className="input-group-append">
                                    <span className="input-group-text">
                                        <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                    </span>
                                </div>
                            </button>
                        </div>
                        {showPreferenceButton && <div className="m-1">
                            <PreferenceRoundButton
                                icon={"gear"}
                                title={lang.preference_button_tooltip}
                                onClick={() => { setShowPreferences(!showPreferences) }}
                            />
                        </div>}
                    </div>
                </div>
            </div>
            {isLoading ?
                <Loader height={"45vh"} /> :
                <div>
                    <Grid
                        data={gridData.map((item) => ({
                            ...item,
                            [SELECTED_FIELD]: selectedState[idGetter(item)],
                        }))}

                        dataItemKey={DATA_ITEM_KEY}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: enableMutliSelect ?? true,
                            drag: false,
                            cell: false,
                            mode: props.mode ?? "multiple",
                        }}
                        ref={gridRef}
                        resizable={true}
                        onColumnResize={handleColumnResize}
                        pageable={isPageable}
                        skip={page.skip}
                        take={page.take}
                        onPageChange={pageChange}
                        total={total}
                        onSelectionChange={onSelectionChange}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                        onRowDoubleClick={onRowDoubleClick}
                        // onHeaderSelectionChange={props.mode == 'single' ? () => {} : onHeaderSelectionChange}
                        style={{ height: props?.height ?? "45vh" }}
                    >
                        {enableMutliSelect && (<GridColumn
                            field={SELECTED_FIELD}
                            width="50px"
                            headerSelectionValue={
                                gridData.findIndex(
                                    (item) => !selectedState[idGetter(item)]
                                ) === -1
                            }
                            locked={true}
                            filterable={false}
                        />
                        )}
                        <GridColumn
                            field={SELECTED_FIELD}
                            width="50px"
                            headerSelectionValue={
                                gridData.findIndex((item) => !selectedState[idGetter(item)]) === -1
                            }
                            locked={true}
                        />
                        {dataColumns.map((column, index) => {
                            if (column.type === COLUMNSTYPE.date) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyDateCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                    />
                                );
                                // }else if (column.name === COLUMNSTYPE.time) {
                            } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TimeCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                    />
                                );
                            } else if (column.name === "SID") {
                                return;
                                //we are not returning any value for SID column
                            } else if (column.type === COLUMNSTYPE.image) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={ImageCell}
                                        title={column.label}
                                        width={column.width ?? 100}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.select) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyDatalookupCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.toggle) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyCustomToggleButton}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.checkbox) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={CheckboxCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.array) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyArrayCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"} //display item in object
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.href) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyHrefCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.localdatetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={LocalDateTimeColumn}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.enum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={EnumCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"} //display item in object
                                        sortable={true}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.imageArrayCell) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={ContentArrayImageCell}
                                        title={column.label}
                                        width={column.width ?? 350}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.provider) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={ProviderCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.multiLangCell) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyMultiLangArrayCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.castType) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={castTypeCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.transmissionTypeStatus) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TransmissionTypeStatusCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.mamStatus) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MAMStatusCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else {
                                return (
                                    column.type !== COLUMNSTYPE.hidden && (
                                        <GridColumn
                                            key={index}
                                            field={column.name}
                                            title={column.label}
                                            width={column.width ?? 200}
                                        />
                                    )
                                );
                            }
                        })}
                    </Grid>
                </div>}
            {/* <div className="text-right mt-1">{`Total : ${count}`}</div> */}
            {showPreferences && filterObj && (
                <UserPreference
                    entityName={filterObj.entityName}
                    preferenceColumnENntityName={filterObj.preferenceEntityName}
                    handleClose={onCloseUserPrefence}
                />
            )}
        </BossDialog>
    );
};

export default AttachMediaCollectionSelection;